import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import ActDetailList from '../components/actDetailList.vue';

formCreate.component('ActDetailList', ActDetailList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      progressList: [],
      chooseAct: [],
      formFunctionCode: 'activity_close_form',
      formParentCode: 'CRM20251014000000002',
      buttonText: {
        submit: '确定关闭',
      },
    };
  },

  async created() {
    this.init();
  },

  methods: {
    // 设置rule
    setRule(item) {
      const v = item;

      return v;
    },

    formComplete() {
      const actDetailList = this.getRule('actDetailList'); // 活动明细列表
      actDetailList.props = {
        ...actDetailList.props,
        actCode: this.formConfig.row.actCode,
        code: this.formConfig.code,
      };
      // 活动明细列表
      actDetailList.on.change = (e) => {
        if (e) {
          this.chooseAct = e;
        }
      };
    },
    // 初始化数据
    async init() {
      const { row } = this.formConfig;
      const data = await request.get('/tpm/tpmActReconsider/query', { id: row.actId || row.id }).then((res) => (res.success ? res.result : []));
      const actDetailList = this.getRule('actDetailList'); // 活动明细列表
      actDetailList.value = data.detailVos || [];
      this.chooseAct = data.detailVos || [];
      this.setValue(data);
    },
  },
};
